export default __webpack_public_path__ + "static/media/demo_01.b814b27e.png";